import { render, staticRenderFns } from "./invitationList.vue?vue&type=template&id=a53511dc&scoped=true&"
import script from "./invitationList.vue?vue&type=script&lang=js&"
export * from "./invitationList.vue?vue&type=script&lang=js&"
import style0 from "./invitationList.vue?vue&type=style&index=0&id=a53511dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53511dc",
  null
  
)

export default component.exports